import React from "react";
import video from '../Taboo.mp4';
import { useNavigate } from "react-router-dom";

export default function Home() {
    const navigate=useNavigate();
    const handleVideoEnd = () => {
      
        // alert('Video has ended');
        navigate('/login');
      };

      return (
        <div className='container'>
        
          <video
          muted
          autoPlay
            onEnded={handleVideoEnd}
            src={video}
          />
        </div>
      );
}
